module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 36
// module chunks = 0